// ============================================================================
// smartLink.js — apertura de enlaces según su destino
// ============================================================================
// Un enlace del MISMO dominio se abre en la misma ventana; si además es una ruta
// de la SPA (/task/...), se navega con el router (transición fluida, sin recarga).
// Un enlace externo (otro dominio/tenant) se abre en una pestaña nueva.
//
// Uso: smartOpenLink(url, navigate)  — navigate = useNavigate() (opcional; sin él,
// los enlaces internos recargan en la misma pestaña en vez de navegar en la SPA).
// ============================================================================

export function smartOpenLink(url, navigate) {
  if (!url) return;
  let u;
  try {
    // Base = origen actual → resuelve tanto URLs absolutas como rutas relativas.
    u = new URL(url, window.location.origin);
  } catch (e) {
    // URL no parseable (mailto:, tel:, esquema raro…) → comportamiento seguro.
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  // Otro dominio → pestaña nueva.
  if (u.origin !== window.location.origin) {
    window.open(u.href, '_blank', 'noopener,noreferrer');
    return;
  }

  // Mismo dominio: ruta de la SPA → navegación interna fluida; si no, misma
  // pestaña con recarga (p. ej. un recurso fuera del router).
  const path = u.pathname + u.search + u.hash;
  if (navigate && u.pathname.startsWith('/task')) {
    navigate(path);
  } else {
    window.location.assign(u.href);
  }
}

export default smartOpenLink;
